import React, { useContext } from "react";
import "./TeamFilter.css";
import { FilterGroup, FilterLayoutContext } from "../FilterBar";

export default function TeamFilter({ teams, selected, onToggle, label = "Teams" }) {
  const layout = useContext(FilterLayoutContext);
  const isSheet = layout === "sheet";
  const hasSelection = selected.length > 0;
  const hint = hasSelection ? `${selected.length} selected` : "All teams";

  return (
    <FilterGroup label={label} hint={isSheet ? hint : null} className="nfl-team-group">
      <div
        className={
          (isSheet ? "nfl-teams nfl-teams-grid" : "nfl-teams nfl-teams-strip") +
          (hasSelection ? " has-selection" : "")
        }
      >
        {teams.map((team) => {
          const isOn = selected.includes(team.abbreviation);
          const fullName = `${team.city} ${team.name}`;
          return (
            <button
              key={team.id}
              type="button"
              className={"nfl-team" + (isOn ? " is-on" : "")}
              style={{ "--team-color": team.primaryColorHex }}
              aria-pressed={isOn}
              title={fullName}
              onClick={() => onToggle(team.abbreviation)}
            >
              <img src={team.logoSrc} alt={fullName} width="26" height="26" />
            </button>
          );
        })}
      </div>
      {isSheet ? null : <span className="nfl-filter-hint">{hint}</span>}
    </FilterGroup>
  );
}
